import React from "react"
import PageIntro from '../../UI/PageIntro/PageIntro'

const paragraphs = [
    <>Pick a topic from the menu above. This is mostly notes I wrote for future me,
        Linux, Bash and Python odds and ends I didn't want to re-Google every time
        I needed them.</>,
]

export default function Pages() {
    return (
        <PageIntro title="Documentation" paragraphs={paragraphs}/>
    )
}
